import React, { ReactElement } from 'react';
import { Box, SxProps } from '@mui/material';

export interface MaterialSymbolProps {
  name: string;

  size?: number;
  color?: string;

  fill?: 0 | 1;
  weight?: number;
  sx?: SxProps;
  className?: string;
  ariaHidden?: boolean;
}

export const MaterialSymbol = ({
  name,
  size = 18,
  color,
  fill = 0,
  weight = 400,
  sx,
  className,
  ariaHidden = true,
}: MaterialSymbolProps): ReactElement => (
  <Box
    component="span"
    className={`material-symbols-outlined${className ? ` ${className}` : ''}`}
    aria-hidden={ariaHidden}
    sx={{
      fontSize: `${size}px`,
      lineHeight: 1,
      color,
      userSelect: 'none',
      fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
      ...sx,
    }}
  >
    {name}
  </Box>
);
